<div class="gallery">
  <app-menu [disabled]="true"></app-menu>
  <app-carousel></app-carousel>
</div>
<app-history></app-history>
<app-sponsors></app-sponsors>
<app-footer></app-footer>
